import React, { useEffect } from 'react'
import Hero from './Hero/Hero'
import Exp from './Exp/Exp'
import Market from './market/Market'
import Case from './case/Case'
import Mission from './mission/Mission'
import Qst from './Qst & Ans/Qst'
import Todo from './To do/Todo'
import Busn from './busn/Busn'
import Footer from './footer/Footer'

const Home = () => {
  return (
    <>
      <Hero />
      <Exp />
      <Market />
      <Case />
      <Mission />
      <Qst />
      <Todo />
      <Busn />
      <Footer />
    </>
  )
}

export default Home
